import React from 'react';
import { useRouter } from 'next/router';
import TechnologyPageTemplate, { TechnologyPageTemplateProps } from './template';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { SEO } from '../../../utils/SEO';

const TechnologyPageComponent: React.FC<TechnologyPageTemplateProps> = ({
  language,
  title,
  html,
  image,
  slug,
}) => {
  const isEn = language === 'en';
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000/';
  const router = useRouter();

  const itemListElements = [
    {
      position: 1,
      name: 'App Masters',
      item: siteUrl,
    },
    {
      position: 2,
      name: `${isEn ? 'Technologies' : 'Tecnologias'} - App Masters - ${
        isEn ? 'Brazil' : 'Juiz de Fora/MG'
      }`,
      item: `${siteUrl}${language}/${isEn ? 'technologies' : 'tecnologias'}`,
    },
    {
      position: 3,
      name: `${title} - App Masters - ${isEn ? 'Brazil' : 'Juiz de Fora/MG'}`,
      item: siteUrl + language + router.asPath,
    },
  ];

  const additionalLinkTags = [
    {
      rel: 'alternate',
      href: siteUrl + `pt/tecnologias/${slug}`,
      hrefLang: 'pt',
    },
    {
      rel: 'alternate',
      href: siteUrl + `en/technologies/${slug}`,
      hrefLang: 'en',
    },
  ];

  return (
    <>
      <NextSeo
        {...SEO({
          pathname: router.asPath,
          locale: language as string,
          title: title as string,
          defaultTitle: {
            enTitle: 'Technology',
            ptTitle: 'Tecnologia',
          },
          description: html as string,
          image: image as string,
        })}
        additionalLinkTags={additionalLinkTags}
      />
      <BreadcrumbJsonLd itemListElements={itemListElements} />
      <TechnologyPageTemplate title={title} html={html} image={image} />
    </>
  );
};

export default TechnologyPageComponent;
